/// <reference types="cordova-plugin-firebase-crashlytics" />
import { Application } from "./scripts/Singletons/Application";

if (window.FirebaseCrashlytics !== undefined) {
    const crashlytics = FirebaseCrashlytics.initialise();
    window.onerror = (errMsg, url, line, column, error) => {
        crashlytics.logException(errMsg.toString())
        return false;
    };
}

PIXI.settings.FAIL_IF_MAJOR_PERFORMANCE_CAVEAT = false;

const canvasDiv = document.createElement("div");
canvasDiv.setAttribute("id", "gameTarget");
document.body.appendChild(canvasDiv);
canvasDiv.appendChild(Application.instance.view);

Application.instance.init();

// @ts-ignore
// tslint:disable
(function(){var script=document.createElement('script');script.onload=function(){var stats=new Stats();document.body.appendChild(stats.dom);requestAnimationFrame(function loop(){stats.update();requestAnimationFrame(loop)});};script.src='//mrdoob.github.io/stats.js/build/stats.min.js';document.head.appendChild(script);})();